/** @format */

import React, { useState, useEffect } from "react";
import style from "./profileUpdatePage.module.css";
import UpdatedStudent from "../../component/UpdatedStudent";
import { useAuth } from "../../context/AuthContext";
import {
  db,
  deleteDoc,
  doc,
  collection,
  getDoc,
  onSnapshot,
} from "../../firebase/utils";
import StudentUpdateForm from "../../forms/StudentUpdateForm";
import EditForm from "../../forms/EditForm";

const ProfileUpdatePage = () => {
  const [editMode, setEditMode] = useState(null);

  const [editContent, setEditContent] = useState();

  const [studentDocs, setStudentDocs] = useState([]);

  const { currentUser } = useAuth();
  //WE DESTRUCTURE THE CURRENT USER I.E CURRENTLY LOGGED IN USER & PROFILE PIC DATA "profilePic" WHICH WILL BE PASSED AS AN ARGUEMENT TO THE USE STORAGE HOOK... FROM USEAUTH

  // let studentCol = collection(db, "users", currentUser?.uid, "students");
  //THE CREATEFORM RENDERS A NEW FORM WHEN SET TO TRUE
  const [createForm, setCreateForm] = useState(false);

  //AFTER GETTING DATA FROM THE FIRESTORE, WE STORE THE THE DATA IN THE STATE {studentDocs}
  //BEFORE RENDERING IT ON THE UI
  // const { studentDocs } = useFireStoreSnap(studentCol);

  //ONSNAPSHOT HOOK EVENT TO RETRIEVE LIVE DATA FROM DB
  useEffect(() => {
    if (!currentUser) {
      //it takes firebase a few milli seconds to authenticate user
      //first, we scheck if users is authenticated
      //if "null" return else grab documments
      return;
    }

    const unsubscribe = onSnapshot(
      collection(db, "users", currentUser?.uid, "students"),
      (snapshot) => {
        let document = [];
        snapshot.docs.forEach((doc) => {
          document.push({ ...doc.data(), id: doc.id });
        });

        setStudentDocs(document);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [currentUser]);

  // DATABASE LOGIC
  //SHOW EDIT FORM

  //DELETE DOC
  const handleDeleteDoc = async (name) => {
    const docRef = doc(db, "users", currentUser?.uid, "students", name);
    const deleteItem = await deleteDoc(docRef);
  
  };

  const handleCreateNewForm = () => {
    if (!editMode) {
      return (
        <StudentUpdateForm
          createForm={createForm}
          setCreateForm={setCreateForm}
        />
      );
    } else {
      return (
        <EditForm
          setEditMode={setEditMode}
          s
          setCreateForm={setCreateForm}
          createForm={createForm}
          handleEditDoc={handleEditDoc}
          editContent={editContent}
        />
      );
    }
  };

  const handleEditDoc = async (id) => {
    const docRef = doc(db, "users", currentUser?.uid, "students", id);
    let document = [];

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      document.push(docSnap.data());
      document.map((data) => {
        setEditContent({ ...data, id: data.id });
      });
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
    // console.log("Document data:", editContent);
    setCreateForm(true);
    setEditMode(true);
  };
  // function filter student

  return (
    <div className={style.container}>
      <div className={style.welcome__note}>
        {!currentUser ? (
          <h4>Loading...</h4>
        ) : (
          <h3>Welcome {currentUser?.displayName}</h3>
        )}
      </div>

      {/* The Add_Form_Btn will only display when the create form is false i.e no active form - */}
      {/* The create form is always set back to false onSubmit */}
      {!createForm && (
        <button
          className={`${style.createForm__btn} ${
            createForm && style.hide__btn
          }`}
          onClick={() => setCreateForm(true)}
        >
          Add New Student
        </button>
      )}

      {createForm && handleCreateNewForm()}
      <div className="updated__student">
        {" "}
        {studentDocs.length >= 1 ? (
          <h3 style={{ color: "#aaa" }}>Updated Student</h3>
        ) : (
          <p
            style={{ color: "#f3f3f3", marginTop: "30vh", textAlign: "center" }}
          >
            No Student's record...
          </p>
        )}
        {studentDocs.map((student, index) => {
          return (
            <UpdatedStudent
              key={student.id}
              handleDeleteDoc={handleDeleteDoc}
              handleEditDoc={handleEditDoc}
              index={index}
              {...student}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProfileUpdatePage;
